import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppInitializerService } from '@app/app-initializer.service';
import { GlobalFunctionService } from '@app/system/services/global-function.service';

@Injectable({
	providedIn: 'root'
})
export class ApiService {

	headers: any = {
		'Content-Type': 'application/json'
	};

	constructor(
		private http: HttpClient,
		private gfService: GlobalFunctionService,
		private appInit: AppInitializerService
	) { }

	getConversationList(params: any, headers: any = {}): Observable<any> {
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		headers = this.gfService.JSONMerge(headers, this.headers);
		const options = {
			headers: new HttpHeaders(headers),
			params
		};
		const api = this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + `conversation`;
		return this.http.get(api, options);
	}

	addConversation(params: any, headers: any = {}): Observable<any> {
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		headers = this.gfService.JSONMerge(headers, this.headers);
		const api = this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + `conversation`;
		const options = {
			headers: new HttpHeaders(headers)
		};
		return this.http.post(api, params, options);
	}

	updatePost(params: any, id: number, headers: any = {}): Observable<any> {
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		const api =
			this.appInit.configuration.API_URL +
			'' +
			this.appInit.configuration.API_PREFIX +
			`conversation/${id}`;
		headers = this.gfService.JSONMerge(headers, this.headers);
		const options = {
			headers: new HttpHeaders(headers)
		};
		return this.http.put(api, params, options);
	}

	updateAnswer(params: any, resourceID: number, messageID: number, headers: any = {}): Observable<any> {
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		headers = this.gfService.JSONMerge(headers, this.headers);
		const options = {
			headers: new HttpHeaders(headers)
		};
		const api = this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + `answer/bestanswer/${resourceID}/${messageID}`;
		return this.http.put(api, params, options);
	}

	deleteConversation(messageID: number, headers: any = {}): Observable<any> {
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		headers = this.gfService.JSONMerge(headers, this.headers);
		const options = {
			headers: new HttpHeaders(headers)
		};
		const api = this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + `conversation/${messageID}`;
		return this.http.delete(api, options);
	}

	conversationLike(messageID: number, headers: any = {}): Observable<any> {
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		headers = this.gfService.JSONMerge(headers, this.headers);
		const options = {
			headers: new HttpHeaders(headers)
		};
		const api = this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + `conversation/like/${messageID}`;
		return this.http.put(api, {}, options);
	}
	conversationUnLike(messageID: number, headers: any = {}): Observable<any> {
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		headers = this.gfService.JSONMerge(headers, this.headers);
		const options = {
			headers: new HttpHeaders(headers)
		};
		const api = this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + `conversation/unlike/${messageID}`;
		return this.http.put(api, {}, options);
	}

	answerLike(messageID: number, headers: any = {}): Observable<any> {
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		headers = this.gfService.JSONMerge(headers, this.headers);
		const options = {
			headers: new HttpHeaders(headers)
		};
		const api = this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + `answer/like/${messageID}`;
		return this.http.put(api, {}, options);
	}

	answerUnLike(messageID: number, headers: any = {}): Observable<any> {
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		headers = this.gfService.JSONMerge(headers, this.headers);
		const options = {
			headers: new HttpHeaders(headers)
		};
		const api = this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + `answer/unlike/${messageID}`;
		return this.http.put(api, {}, options);
	}

	getAnswerList(params: any, headers: any = {}): Observable<any> {
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		headers = this.gfService.JSONMerge(headers, this.headers);
		const options = {
			headers: new HttpHeaders(headers),
			params
		};
		const api = this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + `answer`;
		return this.http.get(api, options);
	}

	addAnswer(params: any, headers: any = {}): Observable<any> {
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		headers = this.gfService.JSONMerge(headers, this.headers);
		const api = this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + `answer`;
		const options = {
			headers: new HttpHeaders(headers)
		};
		return this.http.post(api, params, options);
	}

	updateAnswerPost(params: any, id: number, headers: any = {}): Observable<any> {
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		const api =
			this.appInit.configuration.API_URL +
			'' +
			this.appInit.configuration.API_PREFIX +
			`answer/${id}`;
		headers = this.gfService.JSONMerge(headers, this.headers);
		const options = {
			headers: new HttpHeaders(headers)
		};
		return this.http.put(api, params, options);
	}

	deleteAnswer(messageID: number, headers: any = {}): Observable<any> {
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		headers = this.gfService.JSONMerge(headers, this.headers);
		const options = {
			headers: new HttpHeaders(headers)
		};
		const api = this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + `answer/${messageID}`;
		return this.http.delete(api, options);
	}
}
